export default {
    pagenumber: ["当前第", "页", "共", "页"],
    prev: "上一页",
    next: "下一页",
    error: "文件加载失败",
    openInNewWindow: "新窗口打开",
    continuousMode: "连续模式",
    paginatedMode: "分页模式",
};
